module.exports = __webpack_public_path__ + "img/professional.9c244f2f.svg";